import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VAutocomplete,{attrs:{"dense":"","items":_vm.localPresets,"item-text":"display","item-value":"text","hide-no-data":"","hide-details":"","single-line":"","clearable":"","placeholder":_vm.$t('labels.notes'),"menu-props":{ closeOnContentClick: true },"loading":_vm.loading},model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=$$v},expression:"localValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }